<template>
  <section class="page-rnr">
    <header class="page-rnr-header">
      <div class="page-rnr-title" :class="{active:benzFont}"><slot name="slot-title">{{ title }}</slot></div>
      <div class="page-rnr-back" @click="handleToHome">返回首页<van-icon name="wap-home-o" /></div>
    </header>
    <slot name="slot-before-main" />
    <main class="page-rnr-main">
      <slot />
      <div class="page-rnr-main-fixed-btn-group" v-show="showOperation">
        <slot name="slot-operation" />
      </div>
    </main>
  </section>
</template>

<script>
export default {
  name: 'Page',
  props: {
    title: {
      type: String,
      default: ''
    },
    showOperation: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    benzFont() {
      return localStorage.getItem('source') === 'CIAM'
    }
  },
  activated() {
    this.$nextTick(() => {
      window.scrollTo({ top: 0 })
    })
  },
  methods: {
    /**
     * 跳转到首页
     */
    handleToHome() {
      this.$router.push({ name: localStorage.getItem('source') === 'CIAM' ? 'UserHome' : 'Home' })
    }
  }
}
</script>

<style lang="scss">
.page-rnr {
  background-image: url(../../assets/rnr/bg-header.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: left top;
  .page-rnr-header {
    overflow: hidden;
    padding: 58px 0 0 48px;
    .page-rnr-title {
      color: #FFFFFF;
      font-size: 36px;
      font-weight: 600;
      float: left;
      text-shadow: 0 2px 10px rgba(41,38,169,0.65);
      line-height: 50px;
    }
    .page-rnr-back {
      align-items: center;
      background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%);
      border-radius: 100px 0px 0px 100px;
      color: #FFFFFF;
      display: flex;
      font-size: 20px;
      font-weight: 400;
      float: right;
      width: 140px;
      height: 48px;
      padding-left: 20px;
      .van-icon {
        font-weight: 700;
        margin-left: 8px;
      }
    }
  }
  .page-rnr-main {
    padding-bottom: 184px;
    margin-top: 46px;
    .page-rnr-main-progress {
      color: #FFFFFF;
      font-weight: 500;
      padding: 0 0 20px 48px;
      .page-rnr-main-progress-curr {
        font-size: 46px;
      }
      .page-rnr-main-progress-total {
        color: rgba(255, 255, 255, 0.4);
        font-size: 26px;
      }
      .page-rnr-main-progress-remain {
        font-size: 30px;
        font-weight: 400;
        margin-left: 16px;
      }
    }
    .page-rnr-main-card {
      background: #ffffff;
      border-radius: 16px;
      box-sizing: border-box;
      margin: 0 24px 24px;
      padding: 0px 32px 0;
      .page-rnr-main-card-title {
        color: #242424;
        font-size: 32px;
        font-weight: 500;
        padding: 30px 0 0;
        .page-rnr-icon {
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: inline-block;
          width: 40px;
          height: 40px;
          margin-right: 12px;
        }
      }
      .page-rnr-main-btn {
        color: #0761F3;
        font-size: 24px;
        font-weight: 400;
      }
      .van-list {
        margin-top: 36px;
        .page-rnr-main-btn {
          font-size: 24px;
          margin-left: 30px;
        }
      }
      .van-uploader {
        width: 100%;
        .van-uploader__wrapper {
          display: flex;
          .van-uploader__preview {
            margin: 0 24px 16px 0;
            .van-uploader__preview-image {
              width: 196px;
              height: 196px;
            }
            .van-uploader__preview-delete {
              background-color: rgba(0, 0, 0, .4);
              border-radius: 20px;
              display: flex;
              width: 40px;
              height: 40px;
              .van-uploader__preview-delete-icon {
                font-size: 60px;
                top: -10px;
                right: -10px;
              }
            }
            &:nth-child(3) {
              margin-right: 0px;
            }
          }
        }
      }
    }
    .page-rnr-main-fixed-btn-group {
      background-color: #ffffff;
      bottom: -68px;
      height: 148px;
      padding: 20px 32px;
      position: fixed;
      left: 0px;
      right: 0px;
    }
    .van-cell {
      background-color: transparent;
      padding: 0;

      &.van-field {
        background-color: transparent;
        padding: 44px 0;
        position: relative;
        .van-field__label {
          color: #242424;
          font-size: 32px;
          font-weight: 400;
          height: 45px;
        }
        .van-cell__value {
          height: 45px;
          .van-field__control {
            color: #242424;
            font-size: 32px;
          }
          &.van-field__value {
            position: relative;
            .van-field__error-message {
              position: absolute;
              left: -220px;
              bottom: -90px;
            }
          }
        }
      }
      &.van-cell--required {
        .van-cell__title {
          span {
            padding-left: 20px;
          }
        }
        &:before {
          left: 0px;
          font-size: 16px;
        }
      }
      .van-cell__title {
        span {
          color: #242424;
          font-size: 32px;
          font-weight: 400;
        }
      }
      .van-cell__label {
        margin-top: 36px;
      }
      &:after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
        right: 0px;
        bottom: 0;
        left: 0px;
        border-bottom: 1PX solid #ebedf0 !important;
        transform: scaleY(.5);
      }
    }
  }
  .van-button {
    font-size: 30px;
  }
}
::-webkit-input-placeholder {
  color: #CACACA !important;
  font-weight: 400;
}
:-moz-placeholder {
  color: #CACACA !important;
  font-weight: 400;
}
::-moz-placeholder {
  color: #CACACA !important;
  font-weight: 400;
}
:-ms-input-placeholder {
  color: #CACACA !important;
  font-weight: 400;
}
</style>
<style>
.active{
  font-family: HYZhongsong,Arial,sans-serif;
  transform: scaleX(.7);
}
</style>



// WEBPACK FOOTER //
// src/components/Page/index.vue